import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const CASummaryContractInfo = props => {
  const { selectedContract } = props;
  return (
    <div className="summary-info">
      <div>
        <div className="contract-info-row">
          <div className="contract-info-col">
            <span className="contract-info-heading">Contract Number&nbsp;</span>
            <span>{selectedContract.contractNumber}</span>
          </div>
          <div className="contract-info-col">
            <span className="contract-info-heading">Status&nbsp;</span>
            <span>{selectedContract.status}</span>
          </div>
        </div>
        <div className="contract-info-row">
          <div className="contract-info-col">
            <span className="contract-info-heading">Start&nbsp;</span>
            <span>
              {moment(selectedContract.contractStart).format('MMMM DD, YYYY')}
            </span>
          </div>
          <div className="contract-info-col">
            <span className="contract-info-heading">End&nbsp;</span>
            <span>
              {moment(selectedContract.contractEnd).format('MMMM DD, YYYY')}
            </span>
          </div>
        </div>
        <div className="contract-info-row">
          <div className="contract-info-col">
            <span className="contract-info-heading">Address&nbsp;</span>
            <span>{selectedContract.address.streetAddress}</span>
          </div>
        </div>
        <div className="contract-info-row">
          <div className="contract-info-col">
            <span className="contract-info-heading">
              Internal Contact&nbsp;
            </span>
            <span>{selectedContract.address.internalContact}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

CASummaryContractInfo.propTypes = {
  selectedContract: PropTypes.arrayOf(PropTypes.object),
  address: PropTypes.arrayOf(PropTypes.object),
};

export default CASummaryContractInfo;
